import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import { booleanConvert, stableSort, getSorting, insertIf } from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import Search from '../Common/Search/Search';

import { API } from '../../ws/constants';

class Products extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchData:null
            ,openModal:false
            ,order:'asc'
            ,orderBy:'OrderPos'
            ,page:0
            ,rowsPerPage:10
            ,tableLoading:false
        };
    }

    componentDidMount() {
        this.setState({tableLoading:true});
        fetch(API + "getproducts")
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    deleteRow = (productId) => {
        if(window.confirm("Tem a certeza que quer apagar este produto?")){
            this.setState({tableLoading:true});
            fetch(API + 'deleteproduct&productid=' + productId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, tableLoading:false });
                $(findDOMNode(this.refs["product_" + productId])).remove();
            });
        }
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    handleSearch = (search) => {
        this.setState({ tableLoading:true, page: 0 });
        fetch(API + "searchproducts&keyword="+search)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    render() {
        const { isAdmin, loginData } = this.props;

        const products = this.state.fetchData!=null ? this.state.fetchData.data : []
              , viewCost = isAdmin || loginData.profile.Products.cost
              , viewPrice = isAdmin || loginData.profile.Products.price
              , loadingClass = this.state.tableLoading ? " ajaxLoading" : ""
              , { order, orderBy, rowsPerPage, page } = this.state
              , headerRows = [
                  { id: 'Name', numeric: false, label: 'Nome' },
                  { id: 'SupplierName', numeric: false, label: 'Fornecedor' },
                  ...insertIf(viewPrice, { id: 'PriceWithVat', numeric: false, label: 'Preço com IVA' }),
                  ...insertIf(viewCost, { id: 'CostWithVat', numeric: false, label: 'Custo com IVA' }),
                  { id: 'TotalStock', numeric: false, label: 'Inventário' },
                  { id: 'OrderPos', numeric: true, className: 'smallerHeader', label: 'Pos' },
                  { id: 'IsActive', numeric: false, className: 'smallerHeader', label: 'Ativo' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        return (
            <div id="productsPage">
                <div>
                    <div className="row">
                        <Search searchCallback={this.handleSearch}
                                className="col-12 col-md-4"/>
                        { (isAdmin || loginData.profile.Suppliers) && 
                        <div className="col-12 col-md-8 text-right">
                            <p className="smallMarginTop"><i className="fa fa-dolly"></i> <NavLink to={"/Suppliers/"}>Ver Fornecedores</NavLink></p>
                        </div>
                        }
                    </div>
                    <div className="pageHeader">
                        <h1>
                            <i className="fa fa-boxes"></i> Produtos <span className="arrayCount">({products.length})</span>
                            { (isAdmin || loginData.profile.Products.ADD) && 
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Produto"}
                                        enterDelay={200}>
                                        <span><NavLink className="actionButton success" to={"/Products/New"}><i className="fa fa-plus"></i></NavLink></span>
                                    </Tooltip>
                                </span>
                            }
                        </h1>
                    </div>
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={products.length}>
                        </EnhancedTableHead>
                        <TableBody>
                            {stableSort(products, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(product =>
                            <TableRow key={product.Id} className="tableRow" ref={"product_" + product.Id}>
                                <TableCell data-title="Serviço" className="tableCell">{product.Name}</TableCell>
                                <TableCell data-title="Fornecedor" className="tableCell">
                                    <Tooltip
                                        title={product.SupplierShortname + " - " + product.SupplierName}
                                        enterDelay={200}>
                                        <span><NavLink to={"/Suppliers/"+product.SupplierId}>{product.SupplierName}</NavLink></span>
                                    </Tooltip>
                                </TableCell>
                                { viewPrice &&
                                    <TableCell data-title="Preço com IVA" className="tableCell">
                                        <Tooltip
                                            title={"Preço sem IVA: " + parseFloat(product.PriceWithoutVat).toFixed(2) + "€"}
                                            enterDelay={200}>
                                            <span>{parseFloat(product.PriceWithVat).toFixed(2) + "€"}</span>
                                        </Tooltip>
                                    </TableCell>
                                }
                                { viewCost &&
                                    <TableCell data-title="Custo com IVA" className="tableCell">
                                        <Tooltip
                                            title={"Preço de custo sem IVA: " + parseFloat(product.CostWithoutVat).toFixed(2) + "€"}
                                            enterDelay={200}>
                                            <span>{parseFloat(product.CostWithVat).toFixed(2) + "€"}</span>
                                        </Tooltip>
                                    </TableCell>
                                }
                                <TableCell data-title="Inventário" className="tableCell">{product.TotalStock}</TableCell>
                                <TableCell data-title="Ativo" className="tableCell">{product.OrderPos}</TableCell>
                                <TableCell data-title="Ativo" className="tableCell">{booleanConvert(product.IsActive)}</TableCell>
                                <TableCell data-title="Ações" className="tableCell actions" data-row-id={product.Id}>
                                    {(isAdmin || loginData.profile.Products.permission === 1) &&
                                        <Tooltip
                                            title={"Editar Produto"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton warning" to={"/Products/"+product.Id}><i className="fa fa-pencil-alt"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {loginData.profile.Products && loginData.profile.Products.permission === 2 &&
                                        <Tooltip
                                            title={"Ver Produto"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={"/Products/"+product.Id}><i className="fa fa-eye"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {(isAdmin || loginData.profile.Products.DEL) &&
                                        <Tooltip
                                            title={"Eliminar Produto"}
                                            enterDelay={200}> 
                                            <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteRow(product.Id)}><i className="fa fa-times"></i></button></span>
                                        </Tooltip>
                                    }
                                </TableCell >
                            </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={products.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Products;
